import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatus = () => {
  const currentDate = new Date();
  const formattedDate = currentDate?.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long'
  });
  
  const formattedTime = currentDate?.toLocaleTimeString('ko-KR', {
    hour: '2-digit',
    minute: '2-digit'
  });

  const systemInfo = [
    {
      label: '시스템 상태',
      value: '정상 운영',
      icon: 'CheckCircle2',
      color: 'var(--color-success)'
    },
    {
      label: '서버 응답',
      value: '98ms',
      icon: 'Activity',
      color: 'var(--color-accent)'
    },
    {
      label: '마지막 업데이트',
      value: formattedTime,
      icon: 'Clock',
      color: 'var(--color-primary)'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground">시스템 상태</h3>
        <span className="text-xs text-muted-foreground">{formattedDate}</span>
      </div>
      <div className="space-y-3">
        {systemInfo?.map((info, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Icon name={info?.icon} size={16} color={info?.color} />
              <span className="text-sm text-muted-foreground">{info?.label}</span>
            </div>
            <span className="text-sm font-medium text-foreground">{info?.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SystemStatus;